module.exports = "/_next/static/images/join-the-team-img-a6d6001771531ac86390f638a1936ca9.svg";